// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3kUvb","text":"styles_text__3LCEI"};